import React from "react";

/**
 * Error Boundary — catches any React render error and displays a graceful
 * fallback with the phone number, so the site never goes blank in production.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log to console — useful for debugging in browser devtools
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info);
  }

  handleReload = () => {
    window.location.href = "/";
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        data-testid="error-boundary-fallback"
        style={{
          minHeight: "100vh",
          background: "#0A0A0A",
          color: "#FFFFFF",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "2rem",
          fontFamily: "'Manrope', sans-serif",
        }}
      >
        <div style={{ maxWidth: "560px", textAlign: "center" }}>
          <p
            style={{
              fontSize: "0.72rem",
              textTransform: "uppercase",
              letterSpacing: "0.22em",
              opacity: 0.6,
              margin: 0,
            }}
          >
            Pompes Funèbres
          </p>
          <h1
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: "2.5rem",
              fontWeight: 400,
              lineHeight: 1.1,
              marginTop: "1rem",
              marginBottom: "1.5rem",
            }}
          >
            Lumière des Nations
          </h1>
          <p style={{ opacity: 0.8, lineHeight: 1.6, fontSize: "1rem" }}>
            Une erreur d'affichage est survenue sur cette page. Pour toute urgence,
            n'hésitez pas à nous appeler directement — nous sommes joignables 24h/24.
          </p>
          <a
            href="tel:+33624299100"
            data-testid="error-boundary-call"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.75rem",
              background: "#FFFFFF",
              color: "#0A0A0A",
              padding: "1.1rem 2rem",
              marginTop: "2rem",
              textDecoration: "none",
              fontSize: "0.9rem",
              letterSpacing: "0.05em",
              borderRadius: "2px",
            }}
          >
            ☎ Nous appeler — 06 24 29 91 00
          </a>
          <div style={{ marginTop: "1.5rem" }}>
            <button
              onClick={this.handleReload}
              data-testid="error-boundary-home"
              style={{
                background: "transparent",
                color: "#FFFFFF",
                border: "1px solid rgba(255,255,255,0.3)",
                padding: "0.9rem 1.75rem",
                fontSize: "0.85rem",
                letterSpacing: "0.05em",
                cursor: "pointer",
                borderRadius: "2px",
              }}
            >
              Retour à l'accueil
            </button>
          </div>
          <p
            style={{
              marginTop: "3rem",
              fontSize: "0.75rem",
              opacity: 0.4,
            }}
          >
            14 rue du Ball, 66540 Baho · Disponibles 7j/7 — 24h/24
          </p>
        </div>
      </div>
    );
  }
}
